<template>
    <div class="custom-table">
        <el-table
            ref="custom-table"
            :key="reload"
            :data="tableData.data"
            :row-key="tableOptions.rowKey"
            :height="tableOptions.height"
            :stripe="tableOptions.stripe"
            :border="tableOptions.border"
            :max-height="tableOptions.maxHeight"
            :cell-style="tableOptions.cellStyle"
            :tree-props="tableOptions.treeProps"
            :default-expand-all="tableOptions.defaultExpandAll"
            :highlight-current-row ="tableOptions.highlightCurrentRow"
            :current-row-key="tableOptions.currentRowKey"
            v-loading="tableData.tableLoading"
            :element-loading-background="tableOptions.loadingBackground"
            @row-click="handleRowClick"
            @sort-change="handleSortChange"
            @selection-change="handleSelectionChange">
            <template v-for="(item, i) in tableData.columns">
                <!--具有插槽的列-->
                <el-table-column
                    v-if="item.slot && (item.show != undefined ? item.show : true)"
                    :key="'slot' + i"
                    :label="item.name"
                    :width="item.width * widthRatio"
                    :fixed="item.fixed"
                    :align="item.align ? item.align : 'center'">
                    <template slot="header" slot-scope="scope" >
                        <span v-if="!item.headerSlot">{{item.name}}</span>
                        <slot :name="item.value + 'Header'" :data="scope" v-else></slot>
                    </template>
                    <template  slot-scope="scope" >
                        <slot :name="item.value" :data="scope"></slot>
                    </template>
                </el-table-column>
                <!--正常显示的列-->
                <el-table-column
                    v-if="!item.slot && (item.show != undefined ? item.show : true)"
                    :key="'unique' + i"
                    :type="item.type"
                    :index="indexMethod"
                    :prop="item.value"
                    :label="item.name"
                    :width="item.width * widthRatio"
                    :fixed="item.fixed"
                    :sortable="item.sortable"
                    :show-overflow-tooltip="item.tooltip"
                    :reserve-selection="item.reserveSelection"
                    :align="item.align ? item.align : 'center'">
                    <template slot="header" slot-scope="scope" >
                        <span v-if="!item.headerSlot">{{item.name}}</span>
                        <slot :name="item.value + 'Header'" :data="scope" v-else></slot>
                    </template>
                    <!--具有children的列-->
                    <template v-for="(child, index) in item.children">
                        <el-table-column 
                            :key="'child' + index"
                            v-if="(child.show != undefined ? child.show : true)"
                            :type="child.value"
                            :index="indexMethod"
                            :prop="child.value"
                            :label="child.name"
                            :width="item.width * widthRatio"
                            :fixed="child.fixed"
                            :sortable="item.sortable"
                            :show-overflow-tooltip="child.tooltip"
                            :reserve-selection="child.reserveSelection"
                            :align="child.align ? child.align : 'center'">
                            <template slot="header"  v-if="item.headerSlot">
                                <slot :name="item.value + 'Header'" :data="item" ></slot>
                            </template>
                        </el-table-column>
                    </template>
                </el-table-column>
            </template>

        </el-table>

        <!-- 表格列配置控制 -->
        <div class="column-setting-wrapper" 
            v-if="tableData.tableCharactor"
            @mouseenter="columnSettingBtnShow = true"
            @mouseleave="columnSettingBtnShow = false">
        </div>
        <el-button class="column-setting-btn" 
            v-if="tableData.tableCharactor"
            type="primary"
            :class="{'show': columnSettingBtnShow}"
            @click="columnControllerPanelShow = true"
            @mouseover.native="columnSettingBtnShow = true" 
            @mouseout.native="columnSettingBtnShow = false">
                <i class="iconfont icon-column-controller"></i>
        </el-button>

        <div class="tree-panel" :class="[tableData.theme, {'show': columnControllerPanelShow}]">
            <div class="tree-title">
                <div class="title">
                    <div class="dot"></div>
                    <span>表头设置</span>
                </div>
                <el-button type="text" @click="columnControllerPanelShow = false">
                    <i class="el-icon-close"></i>
                </el-button>
            </div>
            <el-tree
                :ref="'custom-tree'"
                :data="tableData.columns"
                @check="handleNodeClick"
                show-checkbox
                :node-key="'value'"
                :default-checked-keys="checkedColumn"
                :props="{
                    label: 'name'
                }">
            </el-tree>
            <el-button type="primary" @click="confirmColumnSetting">保存</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "custom-table",
    props: {
        options: {
            type: Object,
        },
        table:{
            type: Object,
            default: ()=>{
                return {
                    data: [],
                    columns: [],
                    tableLoading: false,
                    tableCharactor: "", // 用于表头存储的唯一标识
                    theme: "" // 用于控制表头配置面板的样式
                }
            }
        }
    },
    data(){
        return {
            columnSettingBtnShow: false, // 控制列悬浮按钮显示隐藏
            columnControllerPanelShow: false, // 列控制面板显示隐藏
            columnFlag: 1, // 配置比对变量
            tableData: null, // 表格数据
            checkedColumn: [], // 用于保存当前选中的表头（el-tree选中状态字段）
            reload: null, // 用于重载表格数据
            halfKeys: [],
        }
    },
    methods:{
        indexMethod(index){
            index = index + 1;
            let currentPage = this.table.currentPage ? this.table.currentPage : 1;
            if(currentPage === 1){
                return index;
            }else{
                return index + (currentPage - 1)* this.table.pageSize;
            }
        },

        // 行点击事件
        handleRowClick(row){
            this.$emit('rowClick',row);
        },

        // select选择事件
        handleSelectionChange(selection){
            this.$emit('selectionChange',selection);
        },

        // 自定义排序时间
        handleSortChange(value){
            this.$emit('sortChange',value);
        },

        // 表头比对方法（用于比对两个表头是否是一致的）
        columnsArrayCompare(array_1, array_2){
            if(array_1.length != array_2.length)
                this.columnFlag++;
            else{
                for(let i = 0; i < array_1.length; i++){
                    if(array_1[i].name != array_2[i].name || array_1[i].value != array_2[i].value){
                        this.columnFlag++;
                        break;
                    }
                    if(array_1[i].children.length > 0 ){
                        this.columnsArrayCompare(array_1[i].children, array_2[i].children);
                    }
                }
            }
        },

        // 用于初始化表头设置面板的tree的checkStatus
        initColumnsCheckedStatus(s_array){
            if(s_array.length > 0){
                s_array.forEach(item => {
                    if(item.show && item.children.length === 0){
                        this.checkedColumn.push(item.value);
                    }
                    if(item.children.length > 0){
                        this.initColumnsCheckedStatus(item.children);
                    }
                })
            }
        },

        // 利用存储来更新传入的表头的显示字段方法
        updateColumnsCheckedStatusByStore(d_array, s_array){
            for(let i = 0; i < d_array.length; i++){
                if(d_array[i].show != s_array[i].show){
                    d_array[i].show = s_array[i].show;
                }
                if(d_array[i].children.length > 0){
                    this.updateColumnsCheckedStatusByStore(d_array[i].children, s_array[i].children);
                }
            }
        },

        // 表头配置面板的checkbox点击事件
        handleNodeClick(node){
            // 如果当前节点存在子节点，并且当前节点的状态是非选中的。则将当前节点下的子节点都设置为显示
            if(node.children.length > 0 && !node.show){
                node.children.forEach(item => {
                    item.show = true;
                })
            }

            // 如果当前节点不是半选节点
            if(this.halfKeys.indexOf(node.value) < 0){
                node.show = !node.show;

                // 获取当前节点的父级节点
                const parentNode = this.$refs['custom-tree'].getNode(node.value).parent.data;

                // 如果当前节点的父级节点不是数组类型，则表明当前节点为某节点的子节点
                if(!(parentNode instanceof Array)){
                    let flag = 0;
                    parentNode.children.forEach(item => {
                        if(item.show) 
                            flag++;
                    });
                    // 如果所有子节点的状态都是false，则当前节点的父节点显示状态也应该为false
                    if(flag === 0)
                        parentNode.show = false;
                }
            } else {
                // 控制半选状态下的一级节点选中的时候子节点的状态
                node.children.forEach(item => {
                    item.show = true;
                })
            }
            // 后置获取当前半选的节点value
            this.halfKeys = this.$refs['custom-tree'].getHalfCheckedKeys();
            this.reload = Math.random();
            this.$refs['custom-table'].doLayout();
        },

        // 保存表头配置
        confirmColumnSetting(){
            const columnStore = JSON.parse(localStorage.getItem('tableColumnsMap'));
            let flag = 0;
            for(let key in columnStore){
                if(key === this.tableData.tableCharactor){
                    columnStore[key] = [];
                    columnStore[key] = this.tableData.columns;
                    flag++;
                }
            }
            if(flag === 0){
                columnStore[this.tableData.tableCharactor] = this.tableData.columns;
            }
            localStorage.setItem('tableColumnsMap', JSON.stringify(columnStore));
            this.$notify.success({
                title: "设置保存成功"
            });
            this.columnControllerPanelShow = false;
        },

        // 初始化表头show字段方法
        initColumns(s_array){
            s_array.forEach(item => {
                item.show = true;
                if(item.children && item.children.length > 0){
                    this.initColumns(item.children);
                }
            })
        }
    },
    computed:{
        tableOptions(){
            let defaultOptions = {
                'height': null,
                'maxHeight': null,
                'stripe': true, //斑马纹
                'border': false, //纵向边框
                'highlightCurrentRow': false,
                'cellStyle': null, //单元格的 style 的回调方法, function/Object
                'treeProps': {'children': 'children', 'hasChildren': 'hasChildren'},
                'defaultExpandAll': false,
                'rowKey': null, // function / string
                'loadingBackground': 'rgba(255,255,255,0.8)',
                'currentRowKey': null
            };
            for(let key in this.options){
                defaultOptions[key] = this.options[key];
            }
            return defaultOptions;
        },
        widthRatio: () => {
            return window.innerWidth / 1920;
        }
    },
    watch: {
        'table': {
            handler(newVal){
                this.tableData = newVal;

                // 给所有的表头默认添加show字段，默认值为true
                if(this.tableData.columns && this.tableData.columns.length > 0){
                    this.initColumns(this.tableData.columns);
                    
                }
                
                // 如果存在tableCharactor说明表格需要表头配置功能
                if(this.tableData.tableCharactor && this.tableData.columns.length > 0){
                    
                    // 获取表头存储
                    const columnStore = JSON.parse(localStorage.getItem('tableColumnsMap'));

                    // 如果是第一次使用平台，不存在该存储。则初始化一个对象用来保存存储内容。
                    if(columnStore === undefined || columnStore === null){
                        localStorage.setItem('tableColumnsMap', JSON.stringify({}));
                    }else{
                        // 记录存储中是否有当前表格表头的内容
                        let flag = 0;
                        for(let key in columnStore){
                            if(key === this.tableData.tableCharactor && columnStore[key]){

                                // 表头比对。用来控制传入的表头和存储表头的一致性。
                                this.columnsArrayCompare(columnStore[key], this.tableData.columns);
                                flag ++;
                            }
                        }

                        // 如果存储中不存在当前表格的配置，则为0否则保留原有的值。
                        this.columnFlag = (flag === 0 ? flag : this.columnFlag);

                        // 如果存储中存在表格头配置，并且当前传入数据的表头属性与存储中一致
                        if(this.columnFlag === 1){

                            // 用存储数据更新表头的show属性
                            this.updateColumnsCheckedStatusByStore(this.tableData.columns, columnStore[this.tableData.tableCharactor]);
                        }

                        // 如果表头存储中的表头数据和传入的数据不一致
                        if(this.columnFlag > 1){
                            // 用新的表头来替代原始存储数据，并保存
                            columnStore[this.tableData.tableCharactor] = this.tableData.columns;
                            localStorage.setItem('tableColumnsMap', JSON.stringify(columnStore));
                        }
                    }
                    if(columnStore != undefined && columnStore != null)
                        this.initColumnsCheckedStatus(columnStore[this.tableData.tableCharactor]);
                    else
                        this.initColumnsCheckedStatus(this.tableData.columns);

                }
            },
            immediate: true,
            deep: true
        }
    }
};
</script>

<style lang="less">
.custom-table{
    .el-table{
        .el-table__header-wrapper{
            col[name ="gutter"]{
                width: 6px;
            }
            th.gutter{
                width: 6px !important;
            }
        }
        .el-table__body-wrapper{
            table{
                width: 100% !important;
            }

            &::-webkit-scrollbar{
                height: 6px;
                width: 6px;
            }
            &::-webkit-scrollbar-thumb{
                background: #d0d0d0;
            }
        }
        .el-table__fixed{
            bottom: 6px !important;
        }
        .el-button--text{
            font-size: 1.4rem;
            padding: .8rem 0;
            color: #5473E8;
            border: 0;
        }
        .el-button--text.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover{
            color: #C0C4CC
        }
    }

    .el-table--border th:last-child{
        border-right: 0px!important;
    }
    .column-setting-wrapper{
        background: transparent;
        position: fixed;
        z-index: 10001;
        height: 100%;
        width: .2rem;
        right: 0;
        top: 0;
    }

    .column-setting-btn{
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
        transition: all .3s ease-in-out;
        border-radius: .4rem;
        overflow: hidden;
        position: fixed;
        z-index: 10002;
        height: 4rem;
        right: .4rem;
        width: 0rem;
        padding: 0;
        border: 0;
        top: 30%;
        &.show{
            width: 4rem;
        }
        i{
            font-size: 2.4rem;
        }
    }

    .tree-panel{
        padding: 1.2rem 1.2rem .8rem 0rem;
        transition: all .3s ease-in-out;
        border-radius: .8rem;
        background: #fff;
        visibility: hidden;
        max-height: 40rem;
        text-align: right;
        min-width: 18rem;
        position: fixed;
        overflow: auto;
        z-index: 10003;
        right: 1.6rem;
        opacity: 0;
        top: 16vh;
        div.tree-title{
            justify-content: space-between;
            padding: .4rem 0 1.4rem 1.4rem;
            display: flex;
            span{
                color: #333333;
                margin-left: .8rem;
                font-weight: bold;
                font-size: 1.6rem;
            }
            div.dot{
                background: #5473E8;
                display: inline-block;
                height: 1rem;
                width: 1rem;
            }
            .el-button{
                padding: 0;
                margin: 0;
                i{
                    font-size: 1.8rem;
                    font-weight: bold;
                }
            }
        }
        .el-tree{
            background: inherit;

        }
        .el-button{
            padding: .4rem .8rem;
            margin-top: 1.4rem;
        }
        &.show{
            visibility: visible;
            opacity: 1;
        }
        &.light{
            .el-checkbox__inner{
                font-weight: bold;
                background-color: #fff;
                border-color: #5473E8;
            }
            .el-checkbox__inner::after{
                border-color: #5473E8;
            }
            .el-checkbox__input.is-indeterminate .el-checkbox__inner::before{
                background-color: #5473E8;
            }
        }
        &.dark{
            border-color: #074BF7;
            background: #020057;
            border-width: 0.2vh;
            border-style: solid;
            .el-tree-node__content{
                background: #020057;
                color: #fff;
            }
            .el-tree-node__content:hover{
                background: #01003f;
            }
            div.tree-title{
                span{
                    color: #fff;
                }
                div.dot{
                    background: #22FFFD;
                }
                .el-button{
                    padding: 0;
                    margin: 0;
                }
            }
        }
    }
    .el-table__fixed-right-patch{
        background: #5473E8;
    }
}

.dark .custom-table{
    .el-loading-mask{
        background: rgba(3, 0, 66, 0.8) !important;
    }

}
</style>